module.exports = __webpack_public_path__ + "static/media/m_w_hb_25.d9535dac.png";